import { luftGet, luftDelete, luftPost, luftPut } from '../shared/http';
import { loggedUserRequestErrorHandler } from '../shared/http/error';
import { NOTIFICATION_OPTIONS } from '../pages/Admin/shared/notification-types';

// =======================
// actions
// =======================
const GET_COMPANY_NOTIFICATION_SUBS =
  'luft/admin-companies/GET_COMPANY_NOTIFICATION_SUBS';
const GET_COMPANY_NOTIFICATION_SUBS_SUCCESS =
  'luft/admin-companies/GET_COMPANY_NOTIFICATION_SUBS_SUCCESS';
const GET_COMPANY_NOTIFICATION_SUBS_FAILURE =
  'luft/admin-companies/GET_COMPANY_NOTIFICATION_SUBS_FAILURE';

const DELETE_COMPANY_NOTIFICATION_SUB =
  'luft/admin-companies/DELETE_COMPANY_NOTIFICATION_SUB';
const DELETE_COMPANY_NOTIFICATION_SUB_SUCCESS =
  'luft/admin-companies/DELETE_COMPANY_NOTIFICATION_SUB_SUCCESS';
const DELETE_COMPANY_NOTIFICATION_SUB_FAILURE =
  'luft/admin-companies/DELETE_COMPANY_NOTIFICATION_SUB_FAILURE';

const ADD_COMPANY_NOTIFICATION_SUB =
  'luft/admin-companies/ADD_COMPANY_NOTIFICATION_SUB';
const ADD_COMPANY_NOTIFICATION_SUB_SUCCESS =
  'luft/admin-companies/ADD_COMPANY_NOTIFICATION_SUB_SUCCESS';
const ADD_COMPANY_NOTIFICATION_SUB_FAILURE =
  'luft/admin-companies/ADD_COMPANY_NOTIFICATION_SUB_FAILURE';

const UPDATE_COMPANY_NOTIFICATION_SUB =
  'luft/admin-companies/UPDATE_COMPANY_NOTIFICATION_SUB';
const UPDATE_COMPANY_NOTIFICATION_SUB_SUCCESS =
  'luft/admin-companies/UPDATE_COMPANY_NOTIFICATION_SUB_SUCCESS';
const UPDATE_COMPANY_NOTIFICATION_SUB_FAILURE =
  'luft/admin-companies/UPDATE_COMPANY_NOTIFICATION_SUB_FAILURE';

const UPDATE_ADD_SUB_CLEAR_ERRORS =
  'luft/admin-companies/UPDATE_ADD_SUB_CLEAR_ERRORS';

// =======================
// initialState
// =======================
const initialState = {
  notificationSubs: {
    isFetching: false,
    error: '',
    data: [],
  },
  addNotificationSub: {
    isFetching: false,
    error: '',
  },
  updateNotificationSub: {
    isFetching: false,
    error: '',
  },
  deleteNotificationSub: {
    isFetching: false,
    error: '',
  },
};

// =======================
// reducer
// =======================
function reducer(state = initialState, action) {
  switch (action.type) {
    // GET COMPANY NOTIFICAATION SUBS
    case GET_COMPANY_NOTIFICATION_SUBS: {
      return {
        ...state,
        notificationSubs: {
          ...state.notificationSubs,
          isFetching: true,
          error: '',
        },
      };
    }

    case GET_COMPANY_NOTIFICATION_SUBS_SUCCESS: {
      return {
        ...state,
        notificationSubs: {
          ...state.notificationSubs,
          isFetching: false,
          data: action.data,
        },
      };
    }

    case GET_COMPANY_NOTIFICATION_SUBS_FAILURE: {
      return {
        ...state,
        notificationSubs: {
          ...state.notificationSubs,
          isFetching: false,
          error: action.error,
        },
      };
    }

    // DELETE COMPANY NOTIFICATION SUB
    case DELETE_COMPANY_NOTIFICATION_SUB: {
      return {
        ...state,
        deleteNotificationSub: {
          ...state.deleteNotificationSub,
          isFetching: true,
        },
      };
    }

    case DELETE_COMPANY_NOTIFICATION_SUB_SUCCESS: {
      return {
        ...state,
        deleteNotificationSub: {
          ...state.deleteNotificationSub,
          isFetching: false,
        },
      };
    }

    case DELETE_COMPANY_NOTIFICATION_SUB_FAILURE: {
      return {
        ...state,
        deleteNotificationSub: {
          ...state.deleteNotificationSub,
          isFetching: false,
          error: action.error,
        },
      };
    }

    // ADD COMPANY NOTIFICATION SUB
    case ADD_COMPANY_NOTIFICATION_SUB: {
      return {
        ...state,
        addNotificationSub: {
          ...state.addNotificationSub,
          isFetching: true,
        },
      };
    }

    case ADD_COMPANY_NOTIFICATION_SUB_SUCCESS: {
      return {
        ...state,
        addNotificationSub: {
          ...state.addNotificationSub,
          isFetching: false,
        },
      };
    }

    case ADD_COMPANY_NOTIFICATION_SUB_FAILURE: {
      return {
        ...state,
        addNotificationSub: {
          ...state.addNotificationSub,
          isFetching: false,
          error: action.error,
        },
      };
    }

    // UPDATE COMPANY NOTIFICATION SUB
    case UPDATE_COMPANY_NOTIFICATION_SUB: {
      return {
        ...state,
        updateNotificationSub: {
          ...state.updateNotificationSub,
          isFetching: true,
        },
      };
    }

    case UPDATE_COMPANY_NOTIFICATION_SUB_SUCCESS: {
      return {
        ...state,
        updateNotificationSub: {
          ...state.updateNotificationSub,
          isFetching: false,
        },
      };
    }

    case UPDATE_COMPANY_NOTIFICATION_SUB_FAILURE: {
      return {
        ...state,
        updateNotificationSub: {
          ...state.updateNotificationSub,
          isFetching: false,
          error: action.error,
        },
      };
    }

    // CLEAR ERRORS
    case UPDATE_ADD_SUB_CLEAR_ERRORS: {
      return {
        ...state,
        addNotificationSub: {
          ...state.addNotificationSub,
          isFetching: false,
          error: '',
        },
        updateNotificationSub: {
          ...state.updateNotificationSub,
          isFetching: false,
          error: '',
        },
      };
    }

    default: {
      return state;
    }
  }
}

export default reducer;

// =======================
// action creators
// =======================
function _getCompanyNotificationSubs() {
  return { type: GET_COMPANY_NOTIFICATION_SUBS };
}

function _getCompanyNotificationSubsSuccess(data) {
  return {
    type: GET_COMPANY_NOTIFICATION_SUBS_SUCCESS,
    data,
  };
}

function _getCompanyNotificationSubsFailure(error) {
  return {
    type: GET_COMPANY_NOTIFICATION_SUBS_FAILURE,
    error,
  };
}

function _deleteCompanyNotificationSub() {
  return { type: DELETE_COMPANY_NOTIFICATION_SUB };
}

function _deleteCompanyNotificationSubSuccess() {
  return { type: DELETE_COMPANY_NOTIFICATION_SUB_SUCCESS };
}

function _deleteCompanyNotificationSubFailure(error) {
  return {
    type: DELETE_COMPANY_NOTIFICATION_SUB_FAILURE,
    error,
  };
}

function _addCompanyNotificationSub() {
  return { type: ADD_COMPANY_NOTIFICATION_SUB };
}

function _addCompanyNotificationSubSuccess() {
  return { type: ADD_COMPANY_NOTIFICATION_SUB_SUCCESS };
}

function _addCompanyNotificationSubFailure(error) {
  return {
    type: ADD_COMPANY_NOTIFICATION_SUB_FAILURE,
    error,
  };
}

function _updateCompanyNotificationSub() {
  return { type: UPDATE_COMPANY_NOTIFICATION_SUB };
}

function _updateCompanyNotificationSubSuccess() {
  return { type: UPDATE_COMPANY_NOTIFICATION_SUB_SUCCESS };
}

function _updateCompanyNotificationSubFailure(error) {
  return {
    type: UPDATE_COMPANY_NOTIFICATION_SUB_FAILURE,
    error,
  };
}

export function updateAddSubClearErrors() {
  return {
    type: UPDATE_ADD_SUB_CLEAR_ERRORS,
  };
}

// =======================
// thunks
// =======================
export function getCompanyNotificationSubs(CompanyId) {
  return async function (dispatch) {
    dispatch(_getCompanyNotificationSubs());

    const params = {
      CompanyId,
    };

    try {
      const response = await luftGet('/Notification/GetNotification', params);
      dispatch(_getCompanyNotificationSubsSuccess(response.data));
    } catch (error) {
      loggedUserRequestErrorHandler(
        dispatch,
        error,
        _getCompanyNotificationSubsFailure(error.message),
      );
    }
  };
}

export function deleteCompanyNotificationSub(userId) {
  return async function (dispatch) {
    dispatch(_deleteCompanyNotificationSub());

    const params = {
      Id: userId,
    };

    try {
      await luftDelete('/Notification/DeleteNotification', params);
      dispatch(_deleteCompanyNotificationSubSuccess());
      return true;
    } catch (error) {
      console.log(error);
      loggedUserRequestErrorHandler(
        dispatch,
        error,
        _deleteCompanyNotificationSubFailure(error.message),
      );
      throw new Error(error.message);
    }
  };
}

export function addCompanyNotificationSub(userData, companyId) {
  return async function (dispatch) {
    dispatch(_addCompanyNotificationSub());

    const requestBody = {
      name: userData.name,
      email: userData.email,
      companyId,
      typeNotification: NOTIFICATION_OPTIONS.map(notification => {
        const isActive = userData.notificationOptions.indexOf(notification.id);

        return {
          type: notification.id,
          active: isActive >= 0,
        };
      }),
    };

    try {
      await luftPost('/Notification/AddNotification', requestBody);
      dispatch(_addCompanyNotificationSubSuccess());
      return true;
    } catch (error) {
      loggedUserRequestErrorHandler(
        dispatch,
        error,
        _addCompanyNotificationSubFailure(error.message),
      );
      throw new Error(error.message);
    }
  };
}

export function updateCompanyNotificationSub(
  formData,
  companyId,
  subscriberData,
) {
  return async function (dispatch) {
    dispatch(_updateCompanyNotificationSub());

    const requestBody = {
      id: subscriberData.id,
      name: formData.name,
      email: formData.email,
      companyId,
      typeNotification: subscriberData.typeNotification.map(notification => {
        const isActive = formData.notificationOptions.indexOf(
          notification.type,
        );

        return {
          active: isActive >= 0,
          id: notification.id,
          notificationId: notification.notificationId,
          type: notification.type,
        };
      }),
    };

    try {
      await luftPut('/Notification/UpdateNotification', requestBody);
      dispatch(_updateCompanyNotificationSubSuccess());
      return true;
    } catch (error) {
      loggedUserRequestErrorHandler(
        dispatch,
        error,
        _updateCompanyNotificationSubFailure(error.message),
      );
      throw new Error(error.message);
    }
  };
}
